import { clientWithLoader } from '../base/ecommClient';
import { client } from '../base/ecommClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

const phoneValidationClient = body => {
  return client.get(
    endpoint.phoneValidation(body),
    '',
    mapResponse,
    mapError
  );
};

const phoneValidationClientWithLoader = body => {
  return clientWithLoader.get(
    endpoint.phoneValidation(body),
    '',
    mapResponse,
    mapError
  );
};

//map response to object needed by React view
const mapResponse = response => {
  return response;
};

//map error to object needed by React view
const mapError = error => {
 
  if(error.status !== 404) {
    
    error.customErrorCode = 'phoneAPIError';
  }
  else{
    error.isInvalidPhone = true;
  }
  return error;
};

export default phoneValidationClient;
export { phoneValidationClientWithLoader };
